"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTemplateSize = exports.getTemplateSurface = exports.updateBookCoverPrintableIfNeeded = exports.updateBookCoverPrintable = exports.updatePrintable = exports.createPrintable = exports.createDefaultLayers = exports.getLayerDimensions = exports.findLayerInPrintable = void 0;
const EditableTextLayer_1 = require("../../models/layers/EditableTextLayer");
const findLayerInPrintable = (printable, layerId) => {
  const layer = printable.layers.find(l => l.id === layerId);
  return layer;
};
exports.findLayerInPrintable = findLayerInPrintable;
const getLayerDimensions = (printable, layerId) => {
  const layer = printable.layers.find(l => l.id === layerId);
  const wellWidth = printable.surface.width * (layer === null || layer === void 0 ? void 0 : layer.width);
  const wellHeight = printable.surface.height * (layer === null || layer === void 0 ? void 0 : layer.height);
  return {
    wellHeight,
    wellWidth
  };
};
exports.getLayerDimensions = getLayerDimensions;
// EN-6796: The following function is only used in cases where exist defaultData in the layer.
// What it does is to create the userData with the information from the defaultData.
const createDefaultLayers = (layer, surface) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  const defaultTextAlign = ((_a = layer.defaultData.style) === null || _a === void 0 ? void 0 : _a.textAlign) || '';
  const defaultFontFamily = ((_b = layer.defaultData.style) === null || _b === void 0 ? void 0 : _b.fontFamily) || '';
  const defaultFontSize = ((_c = layer.defaultData.style) === null || _c === void 0 ? void 0 : _c.fontSize) || '';
  const defaultContent = `<p style="text-align:${defaultTextAlign}; font-family:${defaultFontFamily}; font-size:${defaultFontSize}">${layer.defaultData.content}</p>`;
  const editableTextLayerUserData = {
    content: defaultContent,
    rawText: layer.defaultData.content,
    fontSize: (_e = (_d = layer === null || layer === void 0 ? void 0 : layer.defaultData) === null || _d === void 0 ? void 0 : _d.style) === null || _e === void 0 ? void 0 : _e.fontSize,
    textAlign: (_g = (_f = layer === null || layer === void 0 ? void 0 : layer.defaultData) === null || _f === void 0 ? void 0 : _f.style) === null || _g === void 0 ? void 0 : _g.textAlign,
    fontFace: (_j = (_h = layer === null || layer === void 0 ? void 0 : layer.defaultData) === null || _h === void 0 ? void 0 : _h.style) === null || _j === void 0 ? void 0 : _j.fontFamily,
    assetId: (0, EditableTextLayer_1.generateTextAssetId)(layer.width, layer.height, layer.defaultData.content || '', surface)
  };
  layer.userData = editableTextLayerUserData;
  // EN-6796: In order to match the assetId with the assetId created by Nisauba,an assetId is generated using the layer.userData.content created above
  const newAssetId = (0, EditableTextLayer_1.generateTextAssetId)(layer.width, layer.height, (_k = layer.userData.content) !== null && _k !== void 0 ? _k : '', surface);
  editableTextLayerUserData.assetId = newAssetId;
  return layer;
};
exports.createDefaultLayers = createDefaultLayers;
var createPrintable_1 = require("./createPrintable");
Object.defineProperty(exports, "createPrintable", {
  enumerable: true,
  get: function () {
    return __importDefault(createPrintable_1).default;
  }
});
var updatePrintable_1 = require("./updatePrintable");
Object.defineProperty(exports, "updatePrintable", {
  enumerable: true,
  get: function () {
    return __importDefault(updatePrintable_1).default;
  }
});
var updateBookCoverPrintable_1 = require("./updateBookCoverPrintable");
Object.defineProperty(exports, "updateBookCoverPrintable", {
  enumerable: true,
  get: function () {
    return __importDefault(updateBookCoverPrintable_1).default;
  }
});
var updateBookCoverPrintableIfNeeded_1 = require("./updateBookCoverPrintableIfNeeded");
Object.defineProperty(exports, "updateBookCoverPrintableIfNeeded", {
  enumerable: true,
  get: function () {
    return __importDefault(updateBookCoverPrintableIfNeeded_1).default;
  }
});
var getTemplateSurface_1 = require("./getTemplateSurface");
Object.defineProperty(exports, "getTemplateSurface", {
  enumerable: true,
  get: function () {
    return getTemplateSurface_1.getTemplateSurface;
  }
});
var getTemplateSize_1 = require("./getTemplateSize");
Object.defineProperty(exports, "getTemplateSize", {
  enumerable: true,
  get: function () {
    return getTemplateSize_1.getTemplateSize;
  }
});
exports.default = exports.getLayerDimensions;